import { atom } from "recoil";

export const chatInputAtom = atom<string>({
  key: "chatInputAtom",
  default: "",
});